import graphql__34f61017a8cd63e83f3d from "./__generated__/SettlementsViewSettlementsQuery.graphql.ts";import * as React from "react";
import {useState, useEffect, useCallback} from "react";
import Panel from "./presentational/Panel";
import {loadQuery, usePreloadedQuery} from "react-relay/hooks";
import {graphql} from "react-relay";
import Headline from "./presentational/Headline";
import SettlementList from "./SettlementList";
import AwesomeDebouncePromise from "awesome-debounce-promise";
import {connect, ConnectedProps} from "react-redux";
import {hideModal, showModal} from "../store/actions";
import type {SettlementsViewSettlementsQuery as SettlementsViewSettlementsQueryType} from "./__generated__/SettlementsViewSettlementsQuery.graphql";
import SettlementsViewSettlementsQuery from "./__generated__/SettlementsViewSettlementsQuery.graphql";
import ListSearch from "./presentational/ListSearch";
import {useSearchParams} from "react-router-dom";
import {useIntl} from "react-intl";

const connector = connect(undefined, {
    dispatchShowModal: showModal,
    dispatchHideModal: hideModal
});

type Props = {
    prepared: any
};

type SettlementsViewProps = ConnectedProps<typeof connector> & Props;

const SettlementsView: React.FC<SettlementsViewProps> = (props) => {
    const intl = useIntl();
    const [searchParams, setSearchParams] = useSearchParams();
    const [searchTerm, setSearchTerm] = useState(searchParams.get('search') || '');
    const [isSearching, setIsSearching] = useState(false);

    const settlements = usePreloadedQuery<SettlementsViewSettlementsQueryType>(
        graphql__34f61017a8cd63e83f3d,
        props.prepared.settlementsQuery,
    );

    // Update URL when search term changes
    const updateURL = useCallback((term: string) => {
        const newParams = new URLSearchParams(searchParams);
        if (term.trim()) {
            newParams.set('search', term);
        } else {
            newParams.delete('search');
        }
        setSearchParams(newParams, { replace: true });
    }, [searchParams, setSearchParams]);

    const searchAPIDebounced = AwesomeDebouncePromise(
        (searchTerm: string) => {
            setSearchTerm(searchTerm);
            updateURL(searchTerm);
        },
        500
    );

    const handleSearchTermChange = (searchTerm: string) => {
        searchAPIDebounced(searchTerm);
    };

    // Initialize search term from URL changes (browser navigation)
    useEffect(() => {
        const urlSearchTerm = searchParams.get('search') || '';
        setSearchTerm(urlSearchTerm);
    }, [searchParams]);

    return (
        <div className="lg:mt-6 mx-auto lg:px-8 grid grid-cols-1 gap-x-4 gap-y-8">
            <Panel>
                <div className="px-6 pt-6 pb-4">
                    <div className="md:flex md:items-center md:justify-between">
                        <div className="flex-1 min-w-0">
                            <Headline>{intl.formatMessage({id: 'view.settlements.headline'})}</Headline>
                        </div>
                    </div>
                    <ListSearch
                        handleSearchTermChange={handleSearchTermChange}
                        placeholder={intl.formatMessage({id: 'view.settlements.searchPlaceholder'})}
                        initialValue={searchTerm}
                        isLoading={isSearching}
                    />
                </div>
                <SettlementList
                    queryRef={settlements}
                    searchTerm={searchTerm}
                    onLoadingChange={setIsSearching}
                />
            </Panel>
        </div>
    )
}

export default connector(SettlementsView);

function prepare_SettlementsView(params: any, relayEnvironment: any) {
    return {
        settlementsQuery: loadQuery(
            relayEnvironment,
            SettlementsViewSettlementsQuery,
            {},
            {fetchPolicy: 'store-and-network'},
        ),
    }
}

export {prepare_SettlementsView};
